import classNames from 'classnames';
import React from 'react';
import s from './syncIndicator.module.scss';

interface Props {
  /** Spins while true; sits still otherwise. */
  active: boolean;
  title?: string;
  className?: string;
}

/**
 * The little arrows that mark a playlist as synced, and turn while a sync is
 * running. Text, not an image, so it inherits the colour of whatever it sits
 * in and costs nothing on a phone.
 */
export default function SyncIndicator({ active, title, className }: Props) {
  return (
    <span
      className={classNames(s.indicator, className, {
        [s.active]: active,
      })}
      title={title}
      role="img"
      aria-label={title || (active ? 'Syncing' : 'Synced')}
    >
      ⟳
    </span>
  );
}
